<template>
    <el-container style="height: 100%" class="groupby">
        <el-main style="height: 100%;padding: 5px">
            <el-form :inline="true" :model="param">
                <el-form-item>
                    <el-popover placement="bottom" trigger="click" v-model="store_data_show" >
                        <div style="height: 500px;width:300px;overflow: auto;overflow-x:auto">
                            <el-tree :data="store_data"
                                     :props="defaultProps"
                                     node-key="id"
                                     :expand-on-click-node="false"
                                     :check-on-click-node="true"
                                     default-expand-all
                                     @node-click="handleNodeClick">
                            </el-tree>
                        </div>
                        <el-input slot="reference" v-model="param.storename" style="width: 100px" size="mini" placeholder="请选择门店" readonly="readonly"></el-input>
                    </el-popover>
                    <el-date-picker style="width: 220px"
                                    value-format="yyyy-MM-dd"
                                    size="mini"
                                    v-model="pickerData"
                                    type="daterange"
                                    align="right"
                                    unlink-panels
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    :clearable="false"
                                    @change="dateChange"
                                    :picker-options="pickerOptions">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>

                </el-form-item>
                <el-form-item>
                    <el-radio-group v-model="param.type">
                        <el-radio :label="1">美容</el-radio>
                        <el-radio :label="2">美发</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="mini" @click="getGroupbyData()" :loading="querybutton">查询</el-button>
                    <!--<el-button type="primary" size="mini" @click="getGroupByDataExcel()">导出</el-button>-->
                </el-form-item>
            </el-form>
            <el-table :data="groupByData" height="calc(100% - 5.5rem)" size="mini" border v-loading="querybutton" show-summary :summary-method="getSummaries">
                <el-table-column label="门店名称" width="100"  align="center" prop="storename" fixed="left"></el-table-column>
                    <el-table-column label="点评美容" v-if="param.type==1" align="center" :key="Math.random()">
                        <el-table-column label="核销" prop="dpbeautyhx" align="center" :key="Math.random()" v-if="param.type==1"></el-table-column>
                        <el-table-column label="核销金额" prop="dpbeautyhxamount" align="center" :key="Math.random()" v-if="param.type==1"></el-table-column>
                        <el-table-column label="成交" prop="dpbeautydeal" align="center" :key="Math.random()" v-if="param.type==1"></el-table-column>
                        <el-table-column label="成交金额" prop="dpbeautydealamount" align="center" :key="Math.random()" v-if="param.type==1"></el-table-column>
                        <el-table-column label="成交率" prop="dpbeautylv" align="center" :key="Math.random()" v-if="param.type==1">
                            <template slot-scope="scope">
                                {{$percentgae(scope.row.dpbeautylv)}}
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="点评美发" v-if="param.type==2" align="center" :key="Math.random()">
                        <el-table-column label="核销" prop="dphairhx" align="center" :key="Math.random()" v-if="param.type==2"></el-table-column>
                        <el-table-column label="核销金额" prop="dphairhxamount" align="center" :key="Math.random()" v-if="param.type==2"></el-table-column>
                        <el-table-column label="成交" prop="dphairdeal" align="center" :key="Math.random()" v-if="param.type==2"></el-table-column>
                        <el-table-column label="成交金额" prop="dphairdealamount" align="center" :key="Math.random()" v-if="param.type==2"></el-table-column>
                        <el-table-column label="成交率" prop="dphairlv" align="center" :key="Math.random()" v-if="param.type==2">
                            <template slot-scope="scope">
                                {{$percentgae(scope.row.dphairlv)}}
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="抖音美容" v-if="param.type==1" align="center" :key="Math.random()">
                        <el-table-column label="核销" prop="dybeautyhx" align="center" :key="Math.random()" v-if="param.type==1"></el-table-column>
                        <el-table-column label="核销金额" prop="dybeautyhxamount" align="center" :key="Math.random()" v-if="param.type==1"></el-table-column>
                        <el-table-column label="成交" prop="dybeautydeal" align="center" :key="Math.random()" v-if="param.type==1"></el-table-column>
                        <el-table-column label="成交金额" prop="dybeautydealamount" align="center" :key="Math.random()" v-if="param.type==1"></el-table-column>
                        <el-table-column label="成交率" prop="dybeautylv" align="center" :key="Math.random()" v-if="param.type==1">
                            <template slot-scope="scope">
                                {{$percentgae(scope.row.dybeautylv)}}
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="抖音美发" v-if="param.type==2" align="center" :key="Math.random()">
                        <el-table-column label="核销" prop="dyhairhx" align="center" :key="Math.random()" v-if="param.type==2"></el-table-column>
                        <el-table-column label="核销金额" prop="dyhairhxamount" align="center" :key="Math.random()" v-if="param.type==2"></el-table-column>
                        <el-table-column label="成交" prop="dyhairdeal" align="center" :key="Math.random()" v-if="param.type==2"></el-table-column>
                        <el-table-column label="成交金额" prop="dyhairdealamount" align="center" :key="Math.random()" v-if="param.type==2"></el-table-column>
                        <el-table-column label="成交率" prop="dyhairlv" align="center" :key="Math.random()" v-if="param.type==2">
                            <template slot-scope="scope">
                                {{$percentgae(scope.row.dyhairlv)}}
                            </template>
                        </el-table-column>
                    </el-table-column>
            </el-table>
        </el-main>
    </el-container>
</template>
<script>
export default {
    data() {
        return {
            querybutton:false,
            groupByData:[],
            pickerData:[
                this.$moment().startOf('month').format('YYYY-MM-DD'),
                this.$moment().endOf('month').format('YYYY-MM-DD')
            ],
            param:{
                storeid:"",
                storename:"",
                type:1,
            },
            store_data_show:false,
            store_data:[],
            defaultProps: {
                children: 'items',
                label: 'name'
            },
            pickerOptions: {
                shortcuts: [
                    {
                        text: '今天',
                        onClick: (picker) => {
                            const start = this.$moment().format('YYYY-MM-DD');
                            picker.$emit('pick', [start, start]);
                        }
                    },
                    {
                        text: '昨天',
                        onClick: (picker) => {
                            const start = this.$moment().subtract(1, 'days').format('YYYY-MM-DD');
                            picker.$emit('pick', [start, start]);
                        }
                    },
                    {
                        text: '本周',
                        onClick: (picker) => {
                            const start = this.$moment().startOf('week').add(1, 'days').format('YYYY-MM-DD');
                            const end = this.$moment().endOf('week').add(1, 'days').format('YYYY-MM-DD');
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '上一周',
                        onClick: (picker) => {
                            const start = this.$moment().startOf('week').subtract(6, 'days').format('YYYY-MM-DD');
                            const end = this.$moment().endOf('week').subtract(6, 'days').format('YYYY-MM-DD');
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '本月',
                        onClick: (picker) => {
                            const start = this.$moment().startOf('month').format('YYYY-MM-DD');
                            const end = this.$moment().endOf('month').format('YYYY-MM-DD');
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '上个月',
                        onClick: (picker) => {
                            const start = this.$moment(this.$moment().format('YYYY-MM-') + '01').startOf('month').subtract(1, 'days').format('YYYY-MM');
                            const num = this.$moment(start, "YYYY-MM-DD").daysInMonth();
                            picker.$emit('pick', [start + '-01', start + '-' + num]);
                        }
                    },
                ],
            }
        }
    },
    created() {
        this.get_store_position_info();
        this.param.storeid=localStorage.getItem("storeid");
        this.param.storename=localStorage.getItem("storename");
        this.getGroupbyData();
        /*let userId = this.getUrlKey("userId");
        let code = this.getUrlKey("code");
        if (userId || code) {
            if (userId) {
                this.getCorpUserInfo(userId);
            }
        } else {
            window.location.href = "http://wechatstaff.shmiaojie.cn:8080/AMNErp/wechatback/getThirdCorpidCodeNew?state=" + encodeURIComponent("http://staff.shmiaojie.cn/#/groupbyingdata");
        }*/
    },
    methods:{
        getSummaries(param){
            const {columns, data} = param;
            const sums = [];
            columns.forEach((column, index) => {
                const values = data.map(item => {
                    if (item["storename"].indexOf("合计") == -1) {
                        return Number(item[column.property]);
                    }
                });

                sums[index] = values.reduce((prev, curr) => {
                    const value = Number(curr);
                    if (!isNaN(value)) {
                        return prev+curr;
                    } else {
                        return prev;
                    }
                }, 0);
            });
            sums[0]="";
            sums[5]=this.$percentgae(sums[3]/sums[1]);
            sums[10]=this.$percentgae(sums[8]/sums[6]);
            sums[15]=this.$percentgae(sums[13]/sums[11]);
            sums[20]=this.$percentgae(sums[18]/sums[16]);
            return sums;
        },
        dateChange(){
            this.getGroupbyData();
        },
        getCorpUserInfo(staffid) {
            this.$post("wechat/getCorpUserInfo", {staffid: staffid}).then(res => {
                if (res.sucess) {
                    let data = res.object;
                    if (data.staff == null || data.staff == undefined) {
                        this.$message.error('没有找到您的信息');
                    } else {
                        this.staff = data.staff;
                        this.staffid=data.staff.staffid;
                        localStorage.setItem("token", data.token);
                        localStorage.setItem("staffid", data.staff.staffid);
                        localStorage.setItem("deptid", data.staff.deptid);
                        localStorage.setItem("staffname", data.staff.staffname);
                        localStorage.setItem("posid", data.staff.posid);
                        localStorage.setItem("storename", data.staff.storename);
                        localStorage.setItem("storeid", data.staff.storeid);
                        localStorage.setItem("parentstoreid", data.staff.storeid);
                        this.get_store_position_info();
                        this.param.storeid=data.staff.storeid;
                        this.param.storename=data.staff.storename;
                        this.getGroupbyData();
                    }
                } else {
                    window.close();
                }
            });
        },
        getGroupbyData(){
            this.querybutton=true;
            let fromdate=this.pickerData[0];
            let todate=this.pickerData[1];
            this.$post("cashreport/getGroupbyData",{storeid: this.param.storeid, fromdate:fromdate, todate:todate}).then(response=>{
                if(response.sucess){
                    this.groupByData=response.object;
                }
                else{
                    this.$message({
                        message: response.message,
                        type: 'error'
                    });
                }
                this.querybutton = false;
            });
        },
        get_store_position_info() {
            this.$post("store/getStoreStructs",{parentid:localStorage.getItem("storeid") }).then(res=>{
                if(res.sucess) {
                    this.store_data = res.object;
                }
            });
        },
        handleNodeClick(data) {
            this.store_data_show = false;
            this.param.storename = data.name;
            this.param.storeid = data.id;
            this.getGroupbyData();
        },
    }
}
</script>
<style style lang="scss" rel="stylesheet/scss">
.groupby .el-form-item{
    margin-bottom:0px;
}
</style>


// WEBPACK FOOTER //
// src/page/groupbyingdata.vue